/**
 * @author Jersson Morales
 * @Copyright (c) Infotrack. All rights reserved.
 */
import { IRespuesta } from '@infotrack/presentacion-transversales/interfacesComunes';
import manejadorRest from '@infotrack/presentacion-utilitarios/manejadorRest';
import { servicioArchivos } from '../../conexiones';
import IArchivo from './entidades/archivo';

export default class ModeloArchivo {

    public async GuardarDocumentoEvidencia(
        archivoFirma: Partial<IArchivo>,
        archivo: File,
    ) {
        const url = "https://serviciosinfotrack.com/Archivos/api/"
        var bodyFetch = new FormData();
        bodyFetch.append('DatosArchivo', JSON.stringify(archivoFirma));
        bodyFetch.append('Archivo', archivo);
        let respuestaPeticion = await fetch(
            `${url}Archivo/GuardarArchivo`,
            {
                method: 'POST',
                body: bodyFetch,
            }
        );
        return respuestaPeticion.status === 200 ? true : false;
    }

    public async GuardarDocumentoFirma(
        archivoFirma: Partial<IArchivo>,
        archivo: File,
    ) {
        const url = "https://serviciosinfotrack.com/Archivos/api/"
        var bodyFetch = new FormData();
        bodyFetch.append('DatosArchivo', JSON.stringify(archivoFirma));
        bodyFetch.append('Archivo', archivo);
        let respuestaPeticion = await fetch(
            `${url}Archivo/GuardarArchivo`,
            {
                method: 'POST',
                body: bodyFetch,
            }
        );
        return respuestaPeticion.status === 200 ? true : false;
    }

    public async ConsultarDocumentoEvidencia(
        archivoFirma: Partial<IArchivo>,
        archivo: File,
    ) {
        const url = "https://serviciosinfotrack.com/Archivos/api/"
        var bodyFetch = new FormData();
        bodyFetch.append('DatosArchivo', JSON.stringify(archivoFirma));
        bodyFetch.append('Archivo', archivo);
        console.log( `${url}Archivo/GuardarArchivo`, "url");
        console.log( servicioArchivos);
        let respuestaPeticion = await fetch(
            `${url}Archivo/GuardarArchivo`,
            {
                method: 'POST',
                body: bodyFetch,
            }
        );
        return respuestaPeticion.status === 200 ? true : false;
    }

     public consultarArchivoIdentificador(archivo:IArchivo) {
        return manejadorRest<IRespuesta<IArchivo>>(() => servicioArchivos.post('Archivo/ListarArchivosIdentificador',archivo));
    }

    public ObtenerArchivo(archivo:IArchivo) {
        return manejadorRest<IRespuesta<IArchivo>>(() => servicioArchivos.post('Archivo/ObtenerArchivo',archivo));
    }
}
